let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("24XDz")).then(() => parcelRequire('4ftBy'));